import { sendEmailVerification, type User, type ActionCodeSettings } from 'firebase/auth';

// Verification completes on the website and returns to the homepage.
export const verificationActionSettings: ActionCodeSettings = {
  url: 'https://givethea.com/',
  handleCodeInApp: false,
};

/** Firebase sends the message; our web action page verifies the code with Firebase. */
export async function sendAccountVerification(user: User): Promise<'sent' | 'failed' | undefined> {
  if (!user.email || user.emailVerified) return undefined;
  try {
    await sendEmailVerification(user, verificationActionSettings);
    return 'sent';
  } catch {
    // Account creation has already succeeded. Offer resend; never retry signup.
    return 'failed';
  }
}
